var d = Object.defineProperty, g = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, $ = Object.prototype.propertyIsEnumerable;
var y = (i, s, t) => s in i ? d(i, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[s] = t, o = (i, s) => {
  for (var t in s || (s = {}))
    A.call(s, t) && y(i, t, s[t]);
  if (v)
    for (var t of v(s))
      $.call(s, t) && y(i, t, s[t]);
  return i;
}, u = (i, s) => g(i, z(s));
var f = (i, s, t) => new Promise((e, n) => {
  var W = (a) => {
    try {
      c(t.next(a));
    } catch (l) {
      n(l);
    }
  }, q = (a) => {
    try {
      c(t.throw(a));
    } catch (l) {
      n(l);
    }
  }, c = (a) => a.done ? e(a.value) : Promise.resolve(a.value).then(W, q);
  c((t = t.apply(i, s)).next());
});
import { a as h, r as p } from "./define-element-XpjsV6s1.js";
import { i as b } from "./utils-CMsllPx8.js";
const w = h({}), m = h(!1), r = h({});
function j(i) {
  var e;
  if (b(i))
    return {};
  const s = Array.isArray(i) ? i : Object.values(i), t = {};
  for (const n of s)
    t[n.sku] = u(o({}, n), { quantity: parseInt((e = n.quantity) != null ? e : "0", 10) });
  return t;
}
function L() {
  function i() {
    return f(this, null, function* () {
      m.value = !0;
      const t = yield p("cart/customer/allocation/wish");
      w.value = j(t), m.value = !1;
    });
  }
  function s(t, e) {
    return f(this, null, function* () {
      r.value = u(o({}, r.value), { [t]: !0 }), yield p(`cart/customer/allocation/wish/items/${t}/${e}`, {
        method: "PUT"
      }), yield i(), r.value = u(o({}, r.value), { [t]: !1 });
    });
  }
  return {
    wish: w,
    isLoadingWish: m,
    isSavingWish: r,
    fetchWish: i,
    updateWishlistQuantity: s
  };
}
export {
  L as u
};
